


























prismic = require '@/utils/prismic/api'
{ textOf } = require '@/utils/prismic/utils'
PrismicDOM = require 'prismic-dom'
module.exports =

	data: ->
		org: null

	created: ->
		@getOrganization()

	methods:

		# Get page data
		getOrganization: ->
			prismic (api) => api.getByUID 'organization', @$route.params.organization
			.then (response) => @org = response.data




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/organization/index.vue